<template>
    <div class="faq">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="collapse_box">
                <div role="tablist">
                    <b-card no-body v-for="(card, index) in cards" v-bind:key="index">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block v-b-toggle="`accordion${index}`">
                                <div class="row align-items-center">
                                    <!-- <div class="col-auto title">{{ card.ObjectId }}</div> -->
                                    <div class="col col-md-8 white_space text-left">{{ card.QuestionDesc }}</div>
                                    <div class="col-auto col-md text-right">
                                        <div class="arrow"></div>
                                    </div>
                                </div>
                            </b-btn>
                        </b-card-header>
                        <b-collapse :id="`accordion${index}`" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <h4 class="title">{{ card.Btitle }}</h4>
                                <p class="card-text">
                                    {{ card.AnswerDesc }}
                                </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import questionAnswerApi from '@/api/questionAnswer'

    export default {
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: '常見問題',
                        active: true
                    }
                ],
                cards: [],
                company: 2
            }
        },
        components: {
            Breadcrumbs,
        },
        methods: {
            queryCompany(id) {
                questionAnswerApi.queryCompany({
                    CompanyId: id
                }, (data) => {
                    this.cards = data ? data : []
                });
            },
            get() {
                questionAnswerApi.get((data) => {
                    this.cards = data ? data : []
                });
            },
            createMetaTag() {
                // Create new meta tags
                const metaImage = document.createElement('meta');
                metaImage.setAttribute('property', 'og:image');
                metaImage.setAttribute('content', 'https://cdn.hola.com.tw/_ui/responsive/theme-trplus/app/images/mobile/index/hola-2023-revision-og.png?1692747001000');
                document.head.appendChild(metaImage);

                const metaTitle = document.createElement('meta');
                metaTitle.setAttribute('property', 'og:title');
                metaTitle.setAttribute('content', 'HOLA 和樂家居｜生活學 – 顧客常見問題');
                document.head.appendChild(metaTitle);

                const metaDescription = document.createElement('meta');
                metaDescription.setAttribute('property', 'og:description');
                metaDescription.setAttribute('content', '參與HOLA生活學課程最常遇到的問題，都可以在這裡找到！想了解更多課程報名、取消、付款、資料修改等問題，都可以解決你的所有疑問！');
                document.head.appendChild(metaDescription);
            },
        },
        watch: {
            company: {
                immediate: true,
                handler(val) {
                    if (val == 0) {
                        this.get()
                    } else if (val == 1) {
                        this.queryCompany('A0')
                    } else if (val == 2) {
                        this.queryCompany('B0')
                    }
                }
            }
        },
        created() {
            this.createMetaTag();
        },
        destroyed() {
            const metaTags = document.querySelectorAll('meta[property^="og:"]');
            metaTags.forEach((metaTag) => {
                metaTag.parentNode.removeChild(metaTag);
            });
        }
    }
</script>
